/**
 * Quando o shell V2 pode envolver a rota atual.
 * Mantém o Cork enquanto ainda estamos no Início legado (`Home`),
 * para não remountar Index dentro do shell novo (quebra Teleport #breadcrumb).
 */
export function shouldUseDashboardV2Shell(isNewDashboardActive, route) {
    if (!isNewDashboardActive) return false;
    const name = route?.name;
    const path = route?.path || '';
    if (name === 'Home' || path === '/' || path === '') {
        return false;
    }
    return true;
}
